import * as React from 'react';
import * as _ from 'lodash';
import createConditional from '../createConditional';
import {isEmpty, ValueType} from '../validation/validators';
import update from 'immutability-helper';
import {
  ComplexCondition,
  NumericOperator,
  ObjectOperator,
  StringOperator,
  UniversalOperator,
} from 'cl-table/redux/actions';
import {ExtendedWrappedFieldExternalProps} from '../FormFields';

const contains = (formValue, disabledByValue: ValueType) => _.includes(formValue, disabledByValue);

const isKeyExists = (formValue, disabledByValue: ValueType) =>
  _.some(formValue, obj => _.includes(_.keys(obj), disabledByValue));

export const isDisabled = (formValue: ValueType, disabledBy: ComplexCondition) => {
  const disabledByValue = disabledBy.value;
  switch (disabledBy.operator) {
    case StringOperator.CONTAINS:
      return contains(formValue, disabledByValue);
    case StringOperator.NOT_CONTAINS:
      return !contains(formValue, disabledByValue);
    case ObjectOperator.KEY_EXISTS:
      return isKeyExists(formValue, disabledByValue);
    case NumericOperator.GT:
      return formValue > disabledByValue;
    case NumericOperator.GTE:
      return formValue >= disabledByValue;
    case NumericOperator.LT:
      return formValue < disabledByValue;
    case NumericOperator.LTE:
      return formValue <= disabledByValue;
    case UniversalOperator.NON_EMPTY:
      return !isEmpty(formValue);
    case UniversalOperator.EMPTY:
      return isEmpty(formValue);
    default:
      return false;
  }
};

export const conditionFieldComponent = _.memoize((name: string, formField: ExtendedWrappedFieldExternalProps) => {
  const FieldComponent = formField.component;
  const disabledBy = _.get(formField.props, 'disabledBy');
  const disabledByKeys = _.keys(disabledBy);
  return disabledBy
    ? update(formField, {
        component: {
          $set: createConditional<any, any>({
            fieldNames: disabledByKeys,
            condition: values =>
              _.some(disabledByKeys, fieldName => isDisabled(values[fieldName], disabledBy[fieldName])),
            props: {disabled: true, input: {value: null}},
          })(props => <FieldComponent {...props} />),
        },
        props: {
          $unset: ['disabledBy'],
        },
      })
    : formField;
});
